<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>OTP Verification</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="app-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>OTP Verification</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <OTPVerification />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from "@ionic/vue";

import OTPVerification from "@/components/customer/ChargingOTPVerification.vue";


export default defineComponent ({
  name: 'chargingOtp',
  components: {
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonBackButton, 
    IonTitle, 
    IonContent,
    OTPVerification
  },
  data() {
    return {

    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    }
  }
})
</script>

<style scoped>
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>